module.exports = __webpack_public_path__ + "img/banner@2x.e68696af.jpg";